import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';

function Assign({ action, variables, setOpenVariable, visible }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.ARRAY.';

    return (
        <div>
            <div className={`conf-field-container ${visible ? "display-none" : ""}`}>
                <FieldLabel name={t(label + 'ARRAY-VARIABLE')} is_required={true} />
                <TextInput action={action} inputName="set" variables={variables}
                    setOpenVariable={setOpenVariable} isRequired include={['array']} fieldType="array" displayName={t(label + 'ARRAY-VARIABLE')} hideRequired={true} />
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'VARIABLE')} is_required={true} />
                <TextInput action={action} inputName="item" variables={variables}
                    setOpenVariable={setOpenVariable} isRequired multiline={4} defaultValue="[]" fieldType="array" displayName={t(label + 'VARIABLE')} hideRequired={true} />
                <small className='conf-field-desc'><em>e.g. ["test","autommate"] or ##arr## or [5,4,3]</em></small>
            </div>
        </div>
    );
}

export default Assign;
